import React from 'react';

import FormattedMessage from '~/components/common/FormattedMessage';
import DefaultButton from '../Default';

import styles from './PremiumButton.scss';

const PremiumButton = ({ children, ...props }) => (
  <div className="text-center">
    <DefaultButton
      {...props}
      target="_blank"
      color="black"
      className={styles.PremiumButton}
    >
      {children || (
      <FormattedMessage
        id="PremiumButton_SupportUs"
        defaultMessage="Support us on patreon"
      />
      )}
    </DefaultButton>
  </div>
);

export default PremiumButton;
